module.exports = __webpack_public_path__ + "static/img/miniAppTab.4a7175d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/miniAppTab.png
// module id = 3N7C
// module chunks = 10